import { Selector } from '@ngrx/store';

import * as RouterStoreSelectors from './router.selector';

export const selectUdid: Selector<object, string | null> = RouterStoreSelectors.selectRouterParam('udid');

export const selectLocationId: Selector<object, string | null> = RouterStoreSelectors.selectRouterParam('locationId');
